// extracted by mini-css-extract-plugin
module.exports = {"icon-agent-size":"icon-agent-size--87765","iconAgentSize":"icon-agent-size--87765"};